(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__emailSignupValidation) return;
    window.__emailSignupValidation = true;

    function parts(input) {
      var box = input.closest('form') && input.closest('form').querySelector('.email-signup__message--validation');
      return box ? { box: box, text: box.querySelector('.email-signup__validation-text') } : null;
    }

    // `invalid` doesn't bubble, so listen in the capture phase. Native
    // validation (and its bubble) still runs; this only adds inline feedback.
    document.addEventListener(
      'invalid',
      function (event) {
        var input = event.target;
        if (!input.matches || !input.matches('.email-signup__input')) return;
        var p = parts(input);
        if (!p) return;
        p.text.textContent = input.validationMessage || p.box.dataset.fallback;
        p.box.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      },
      true
    );

    document.addEventListener('input', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('.email-signup__input')) return;
      var p = parts(input);
      if (!p || p.box.hidden) return;
      if (input.validity.valid) {
        p.box.hidden = true;
        p.text.textContent = '';
        input.removeAttribute('aria-invalid');
      } else {
        p.text.textContent = input.validationMessage || p.box.dataset.fallback;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
